import React from "react";
import IPage from "../../interfaces/page"
import ClientsComponent from "../../components/Clients/Clients.component";

const ClientsPage: React.FunctionComponent<IPage> = (props: IPage) => {
  return <ClientsComponent></ClientsComponent>;
};

export default ClientsPage;
